import React from "react";
import "../App.css";

const Prevention: React.FC = () => {
  return <div className="Prevention"> Prevention</div>;
};

export default Prevention;
